const DOCUMENT_SUBMENU_LIST = {
    "KIOCH Child Sponsor" : "KIOCH child sponsor.pdf",
    "K-PALS UK Trustee's Annual Report" : "K-PALS UK Trustee's Annual Report.pdf",
    "Naming Opportunity" : 'namingOpportunity.pdf' ,
    "Trainee Recruitment Policy" : 'Trainee-recruitment-policy.pdf',
    "Letter of Gratitude from Dr Agrawal" : "letter-of-gratitude-from-Dr-Agrawal.pdf",    
};

export default DOCUMENT_SUBMENU_LIST;